/*
 * @Author: Bai.Zhiming
 * @Date: 2019-11-25 12:52:23
 * @LastEditTime: 2021-03-24 19:00:55
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\MC\message\messageRouter.js
 * @Description: 消息中心路由 
 */

angular.module('messageRouterModule', [])
    . config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('front.mc.message', {
            url: '/message',
            views: {
                'main@front.mc': {
                    template: '<div class="m_c_message" ui-view="main"></div>',
                }
            }
        }).state('front.mc.message.collaborationmessage', {
            url: '/collaborationmessage',
            views: {
                'main@front.mc.message': {
                    templateUrl: './MC/message/collaborationMessage/collaborationMessage_tpl.html',
                    controller: 'collaborationMessageCtrl'
                }
            }
        }).state('front.mc.message.resourceupdatemessage', {
            url: '/resourceupdatemessage',
            views: {
                'main@front.mc.message': {
                    templateUrl: './MC/message/resourceUpdateMessage/resourceUpdateMessage_tpl.html',
                    controller: 'resourceUpdateMessageCtrl'
                }
            }
        }).state('front.mc.message.propagandadepartmentmessage', {
            url: '/propagandadepartmentmessage',
            views: {
                'main@front.mc.message': {
                    templateUrl: './MC/message/propagandaDepartmentMessage/propagandaDepartmentMessage_tpl.html',
                    controller: 'propagandaDepartmentMessageCtrl'
                }
            }
        }).state('front.mc.message.systemmessage', {
            url: '/systemmessage',
            views: {
                'main@front.mc.message': {
                    templateUrl: './MC/message/systemMessage/systemMessage_tpl.html',
                    controller: 'systemMessageCtrl'
                }
            }
        }).state('front.mc.message.messagereceivingconfig', {
            url: '/messagereceivingconfig',
            views: {
                'main@front.mc.message': {
                    templateUrl: './MC/message/messageReceivingConfig/messageReceivingConfig_tpl.html',
                    controller: 'messageReceivingConfigCtrl'
                }
            }
        }).state('mcmessagedetail', {
            url: '/mcmessagedetail?messageid',
            views: {
                '': {
                    templateUrl: './MC/message/messageDetail/messageDetail_tpl.html',
                    controller: 'mcMessageDetailCtrl'
                }
            }
        });
    }]);
